module.exports = __webpack_public_path__ + "static/media/video.b6b3725c.vtt";